























































































































































import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import ReservationCardDetails from '@/components/Reservations/ReservationCardDetails.vue';
import { getLowestUtilizedEntrance, logError, apiDeleteRequest } from '../../helpers';
import { ReservationEntity, EntranceEntity, CancelReservationOptions, APIDeleteRequest, GetExternalUserReservationsOptions } from '../../../../types';

const apiBaseURL = process.env.VUE_APP_API_URL || '';

export default Vue.extend({
  name: 'reservation-card',
  components: {
    ReservationCardDetails,
  },
  props: {
    cardReservation: {
      type: Object,
      required: true,
    },
    cardManualGroup: {
      type: Object,
      required: false,
    },
    cardLocation: {
      type: Object,
      required: false,
    },
    cardEntrance: {
      type: Object,
      required: false,
    },
    cardTimeslot: {
      type: Object,
      required: false,
    },
    cardVisitType: {
      type: Object,
      required: false,
    },
  },
  methods: {
    viewReservation() {
      this.$router.push({
        name: 'reservation-details',
        params: {
          reservationQRCode: this.cardReservation.qrCode,
        },
        query: {
          customerId: (this as any).customerId,
          lang: this.$root.$i18n.locale,
        },
      });
    },
    checkIn() {
      this.$router.push({
        name: 'location-check-in',
        params: {
          reservationQRCode: this.cardReservation.qrCode,
        },
      });
    },
    modifyReservation() {
      this.$router.push({
        name: 'modify-reservation',
        params: {
          reservationQRCode: this.cardReservation.qrCode,
          reservationLocationId: this.cardReservation.locationId.toString(),
        },
      });
    },
    handleCancelReservation(): void {
      (this as any).$Simplert.open({
        title: this.$t('text.are_you_sure'),
        message: this.$t('text.are_you_sure_cancel'),
        type: 'warning',
        customCloseBtnText: this.$t('text.close'),
        customCloseBtnClass: 'btn fourth-button',
        useConfirmBtn: true,
        onConfirm: this.cancelReservation,
        customConfirmBtnText: this.$t('text.cancel_reservation'),
        customConfirmBtnClass: 'btn primary-button',
      });
    },
    async cancelReservation(): Promise<void> {
      (this as any).showLoader();

      const customerId = this.cardReservation.customerId;
      const locationId = this.cardReservation.locationId;
      const reservationId = this.cardReservation.id;
      const externalUserId = this.cardReservation.externalUserId;

      const deleteOptions: APIDeleteRequest = {
        apiKey: externalUserId,
        apiURL: `${apiBaseURL}customer/${customerId}/location/${locationId}/reservation/${reservationId}`,
      };

      const deleteRequest = await apiDeleteRequest(deleteOptions);

      if (deleteRequest) {
        const getOptions: GetExternalUserReservationsOptions = {
          externalUserId,
          customerId,
        };

        await this.$store.dispatch('appData/GET_EXTERNAL_USER_RESERVATIONS', getOptions);

        (this as any).hideLoader();
      } else {
        (this as any).hideLoader();

        (this as any).$Simplert.open({
          title: this.$t('text.reservation_error'),
          message: this.$t('text.reservation_cancel_error_message'),
          type: 'warning',
          customCloseBtnText: this.$t('text.close'),
          customCloseBtnClass: 'btn fourth-button',
          useConfirmBtn: true,
          onConfirm: this.cancelReservation,
          customConfirmBtnText: this.$t('text.try_again'),
          customConfirmBtnClass: 'btn primary-button',
        });
      }
    },
  },
  computed: {
    isFuture(): boolean {
      return !this.cardManualGroup ? moment().isBefore(moment(`${this.cardReservation.startDate}T${this.cardTimeslot.startTime}`)) : false;
    },
    doesNotHaveScans(): boolean {
      return this.cardReservation.scans.length === 0;
    },
  },
});
